var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"nav-bar"},[_c('ul',{staticClass:"nav-bar__list"},_vm._l((_vm.links),function(ref,index){
var link = ref.link;
var label = ref.label;
return _c('li',{key:(link + "-" + index),staticClass:"nav-bar__item",on:{"click":function($event){return _vm.scrollTo(link)}}},[_c('a',{staticClass:"nav-bar__link",attrs:{"href":"#","draggable":"false"}},[_vm._v(_vm._s(label))])])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }